var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpvote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.167a8.833 8.833 0 100 17.666 8.833 8.833 0 000-17.666zm-.001 5.077l.07.004.057.01.018.004.023.007.02.006.03.011a.579.579 0 01.056.026l.03.017.028.018a.58.58 0 01.019.014l.028.024.026.022 3.179 3.053a.583.583 0 01-.735.901l-.073-.06-2.192-2.105v4.957a.583.583 0 01-1.161.08l-.005-.08-.001-4.913-2.15 2.162a.583.583 0 01-.889-.75l.062-.073 3.148-3.163.035-.032.013-.012-.047.043.061-.053.047-.032.036-.02a.59.59 0 01.106-.043l.032-.008a.538.538 0 01.035-.007l.02-.003.056-.005H10z",
    fill: "var(--icon-light-gray)",
    fillRule: "nonzero"
  }))));
}
export default SvgUpvote;